import React from 'react';
import { Badge } from 'reactstrap';

export default function DialogInformation({ elem }) {
  return (
    <div>
      <h2>{elem.displayName}</h2>
      <Badge
        color=""
        style={{ Color: '#fff', backgroundColor: '#ffd54f' }}
        className="mb-1"
      >
        <span>{elem.name}</span>
      </Badge>
    </div>
  );
}
